import React, { useEffect, useState } from 'react';
import Navigation from './Navigation';
import "./Bs.css";
import { FaPlay } from 'react-icons/fa';
import { Helmet } from 'react-helmet';

const Bs = () => {
  const [activeButton, setActiveButton] = useState('video');
  const [mainSrc, setMainSrc] = useState('assets/Gadh1.mp4');
  const [isVideo, setIsVideo] = useState(true);
  const [plotsLeft, setPlotsLeft] = useState(34);

  useEffect(() => {
    document.body.classList.add('bg-white');
    setMainSrc('assets/Gadh1.mp4');
    setIsVideo(true);

    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateNumber();
          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(document.querySelector('.number'));

    function animateNumber() {
      const startValue = 34;
      const endValue = 26;
      const duration = 3000;
      const stepTime = Math.abs(Math.floor(duration / (startValue - endValue)));

      let currentValue = startValue;

      const step = () => {
        setPlotsLeft(currentValue);
        if (currentValue > endValue) {
          currentValue--;
          setTimeout(step, stepTime);
        }
      };

      step();
    }

    return () => observer.disconnect();
  }, []);

  const handleThumbnailClick = (type, src) => {
    setIsVideo(type === 'video');
    setMainSrc(src);
  };

  const handleButtonClick = (button) => {
    setActiveButton(button);
    setIsVideo(button === 'video');
    setMainSrc(button === 'video' ? 'assets/Gadh1.mp4' : 'assets/G1.jpg');
  };

  return (
    <>
        <Helmet>
        <title>Best Sellers | Farmhouse Plots and Villas Near Nature</title>
        <meta name="description" content="Find your dream farmhouse plot or villa surrounded by serene nature, perfect for farmhouse living and small farming. Explore gated communities and secure your slice of paradise today!" />
        <meta name="keywords" content="Farmhouse plots, Villas, Gated community, Nature escape, Low population density, Farming, Affordable plots, Green living, Best sellers" />
      </Helmet>
      
      <Navigation />

      <div className="primel">
        <div className="pvheading">
          <button
            id="videoBtn"
            className={`button ${activeButton === 'video' ? 'active' : ''}`}
            onClick={() => handleButtonClick('video')}
          >
            Videos
            <div className="line"></div>
            <div className="line"></div>
          </button>
          <button
            id="photoBtn"
            className={`button ${activeButton === 'photo' ? 'active' : ''}`}
            onClick={() => handleButtonClick('photo')}
          >
            Photos
            <div className="line"></div>
            <div className="line"></div>
          </button>
        </div>

        <div className="main-slider-container">
          <div className="main-slider">
            {isVideo ? (
              <video id="mainVideo" src={mainSrc} controls autoPlay muted playsInline preload="none" />
            ) : (
              <img id="mainPhoto" src={mainSrc} alt="Featured Property" loading="lazy"/>
            )}
          </div>
        </div>

        {activeButton === 'video' ? (
          <div className="thumbnail-container video-thumbnails">



            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/G8.jpg"
              alt="Gadh1 video thumbnail"
                onClick={() => handleThumbnailClick('video', 'assets/Gadh1.mp4')}
              />
              <i className="fa-solid fa-play play-icon" onClick={() => handleThumbnailClick('video', 'assets/Gadh1.mp4')}>
              <FaPlay/>
              </i>
            </div>


            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/G3.jpg"
          alt="Gadh3 video thumbnail"
                onClick={() => handleThumbnailClick('video', 'assets/Gadh3.mp4')}
              />
              <i className="fa-solid fa-play play-icon"  onClick={() => handleThumbnailClick('video', 'assets/Gadh3.mp4')}>
              <FaPlay/>
              </i>
            </div>



            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/M5.jpg"
              alt="Gadh2 video thumbnail"
                onClick={() => handleThumbnailClick('video', 'assets/Gadh2.mp4')}
              />
              <i className="fa-solid fa-play play-icon"    onClick={() => handleThumbnailClick('video', 'assets/Gadh2.mp4')}>
              <FaPlay/>
              </i>
            </div>

            <div className="thumbnail-wrapper">
              <img
                className="thumbnail"
                data-type="video"
                src="assets/G3.jpg"
                alt=" Gadh Video 3"
                onClick={() => handleThumbnailClick('video', 'assets/Gadh3.mp4')}
              />
              <i className="fa-solid fa-play play-icon"  onClick={() => handleThumbnailClick('video', 'assets/Gadh3.mp4')}>
              <FaPlay/>
              </i>
            </div>
            
          </div>
        ) : (
          <div className="thumbnail-container photo-thumbnails">
            <img
              className="thumbnail"
              data-type="photo"
              src="assets/G1.jpg"
              alt="Photo 1"
              onClick={() => handleThumbnailClick('photo', 'assets/G1.jpg')}
            />
            <img
              className="thumbnail"
              data-type="photo"
              src="assets/G2.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/G2.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/G3.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/G3.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/G4.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/G4.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/G5.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/G5.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/G6.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/G6.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/G7.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/G7.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/G8.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/G8.jpg')}
            />
               <img
              className="thumbnail"
              data-type="photo"
              src="assets/G9.jpg"
              alt="Photo 2"
              onClick={() => handleThumbnailClick('photo', 'assets/G9.jpg')}
            />
          </div>
        )}
      </div>













      <div className="primecards">
        <div className="descpcards">

        <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Nature's Retreat-A Peaceful Escape</h5>
              <h6 className="card-subtitle mb-2 text-muted">Escape to serene greenery, Far from the noise, close to nature, perfect for farmhouse living and small farming.</h6>
            </div>
          </div>


          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Gated Community Bliss</h5>
              <h6 className="card-subtitle mb-2 text-muted">Secure, well-gated society for peaceful living and privacy.</h6>
            </div>
          </div>


          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Farmhouse Villas Near You</h5>
              <h6 className="card-subtitle mb-2 text-muted">Just outside the city, your dream villa surrounded by nature.</h6>
            </div>
          </div>

          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Limited Population, Unlimited Peace</h5>
              <h6 className="card-subtitle mb-2 text-muted">Experience tranquility with low population density – your perfect retreat.</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Secure Your Slice of Paradise</h5>
              <h6 className="card-subtitle mb-2 text-muted">Selling fast – 20-27 plots already booked! Don’t miss your chance.</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Lush Green Living</h5>
              <h6 className="card-subtitle mb-2 text-muted">Embrace the fresh air and greenery all around you.</h6>
            </div>
          </div>
          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Your Farming Paradise</h5>
              <h6 className="card-subtitle mb-2 text-muted">Grow your own food with ample space for small-scale farming.</h6>
            </div>
          </div>

          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Affordable Farmhouse Plots</h5>
              <h6 className="card-subtitle mb-2 text-muted">Great prices for your next investment in a green future.</h6>
            </div>
          </div>

          <div className="descard">
            <div className="card-body">
              <h5 className="card-title">Your Villa, Your Garden</h5>
              <h6 className="card-subtitle mb-2 text-muted">Perfect land for a villa with space to create your own garden.</h6>
            </div>
          </div>

        </div>
      </div>

      <div className="primelfoot">
        <div className="googlemaps">
        <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13997.861917109709!2d78.08865!3d28.705632!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390b7b003fa65f01%3A0xa24988531d924a00!2sPratapgarh%20Farms!5e0!3m2!1sen!2sin!4v1726306651162!5m2!1sen!2sin" 
            width="600"
            height="450"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="number">
          <p>Only <span>{plotsLeft}</span> Plots Left</p>
        </div>
        <div className="contactlink">
          <a href="/contact">Book Now!!</a>
        </div>
        <div className="naksha">

        <img class="nakshaimg"  src="assets/bsnaksha.jpg" alt="Plot Map" loading="lazy" />
        </div>
      </div>
    </>
  );
};

export default Bs;
